import { clearCachedCurrentToken, getCachedCurrentToken, setCachedCurrentToken } from './cache';
import { fetchToken } from './fetchToken';
import { getLoginUrl } from '../helpers/config';
let latestTokenPromise = null;
export const clearToken = () => {
  clearCachedCurrentToken();
};
export const getAuthenticationUrl = res => res.authenticationUrl;

// IMPORTANT! change the version here anytime `innerGetCurrentTokenWithoutRedirect` is being updated!
const getTokenFunctionVersion = 1;
const innerGetCurrentTokenWithoutRedirect = () => {
  if (latestTokenPromise) {
    return latestTokenPromise;
  }
  const currentToken = getCachedCurrentToken();
  if (!currentToken || new Date(currentToken.expiresAt).getTime() - Date.now() <= 300 * 1000) {
    latestTokenPromise = fetchToken().then(token => {
      latestTokenPromise = null;
      setCachedCurrentToken(token);
      return token;
    }).catch(e => {
      latestTokenPromise = null;
      if (getAuthenticationUrl(e)) {
        clearToken();
      }
      throw e;
    });
    return latestTokenPromise;
  }
  return Promise.resolve(currentToken);
};
const globalGetTokenFunctionKeyName = '__ACSGetAccessToken';
const globalGetTokenFunctionVersionKeyName = '__ACSGetAccessTokenVersion';
export const getCurrentTokenWithoutRedirect = () => {
  let fn = window[globalGetTokenFunctionKeyName];
  const fnVersion = window[globalGetTokenFunctionVersionKeyName];
  if (!fn || !fnVersion || fnVersion < getTokenFunctionVersion) {
    fn = window[globalGetTokenFunctionKeyName] = innerGetCurrentTokenWithoutRedirect;
    window[globalGetTokenFunctionVersionKeyName] = getTokenFunctionVersion;
  }
  return fn();
};
export const getCurrentToken = () => getCurrentTokenWithoutRedirect().catch(e => {
  const authenticationUrl = getAuthenticationUrl(e);
  if (authenticationUrl) {
    window.location.assign(authenticationUrl);
  }
  throw e;
});
export const logout = function () {
  let redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  clearToken();
  window.location.assign("".concat(getLoginUrl(), "/api/v1/authentication/logout?redirectUrl=").concat(redirectUrl));
};
export const convertToDocsToken = _ref => {
  let {
    accessToken,
    expiresAt
  } = _ref;
  return {
    token: accessToken,
    token_expiration: Math.round((new Date(expiresAt).getTime() - Date.now()) / 1000)
  };
};
//# sourceMappingURL=getCurrentToken.js.map